export default __webpack_public_path__ + "static/media/crypto_payments.eddc466a.svg";